import { renderTopLevelComponent } from 'app/scripts/controller/renderTopLevelComponent';
import { LazyPowerUpDirectory } from 'app/src/components/PowerUpDirectory';
import { controllerEvents } from './controllerEvents';

export const powerupPublicDirectoryPage = () => {
  controllerEvents.trigger('setViewType', 'power-ups');
  renderTopLevelComponent(<LazyPowerUpDirectory />);
};
